// Crypto Wallets → Custody → Collections (SM-267, split out of the old
// /wallet-ops/orders tab bar). Sweeps that move settled deposits from user
// addresses into the cold wallet — internal treasury automation, not a
// user-initiated flow.
import { createFileRoute } from "@tanstack/react-router";
import {
  CollectionsTable,
  OrderListPage,
  useAssetMap,
} from "@/components/wallet-ops/orders";
import { fetchCryptoCollectionOrders } from "@/lib/wallet-queries";
import type { CryptoCollectionOrder } from "@/lib/wallet-types";

export const Route = createFileRoute("/_app/wallet-ops/collections")({
  component: CollectionsPage,
});

function CollectionsPage() {
  const assets = useAssetMap();
  return (
    <OrderListPage<CryptoCollectionOrder>
      title="Collections"
      description="Sweeps that move settled deposits from user addresses into the cold wallet. Hover any value for the raw wire form; click to copy."
      cardTitle="Collection orders"
      tab="collections"
      fetcher={fetchCryptoCollectionOrders}
      renderTable={(items) => <CollectionsTable items={items} assets={assets} />}
    />
  );
}
